<template>
  <div id="expend-list" class="carrier-list-data">
    <div class="summary din" @click="$emit('close')">
      <div class="date">{{ formatDate(liveStreamLog[0].date.toString()) }}</div>
      <div>当日对外打赏了 {{ $retainWan(totalPeople) }}人，合计价值 ¥ {{ $kuaibiCoin(totalGift) }}</div>
      <van-icon class="close-btn" name="cross" />
    </div>
    <div v-for="(item, index) in tableData" :key="item.eid" class="item-default" @click="toDefault(item)">
      <div class="commodity-sort">{{ index + 1 }}</div>
      <div class="item-icon icon-radius">
        <img :src="$_.get(item, 'anchor.avatar',defaultAnchorIcon)" alt="头像">
      </div>
      <div class="center-anchor-goods">
        <div class="item-name">{{ $_.get(item, 'anchor.name', $_.get(item, 'name')) }}</div>
        <div class="item-fans din">{{ $_.get(item, 'anchor.fans') ? $retainWan($_.get(item, 'anchor.fans')) : '0' }} 粉丝</div>
        <div class="item-tag-contain" v-if="!$_.isEmpty($_.get(item, 'eCommerceTag'))">
          <div class="default-tag" v-for="(tag, index) in $_.get(item, 'eCommerceTag')" :key="index">{{ tag }}</div>
        </div>
      </div>
      <div class="data-for-detail">
        <div class="data-title">打赏礼物价值</div>
        <div class="data-number data-number-red">¥{{ $kuaibiCoin($_.get(item, 'currency')) }}</div>
      </div>
    </div>
    <footer>
      已显示对外打赏的全部主播
    </footer>
  </div>
</template>

<script>
export default {
  props: { liveStreamLog: Array },
  data() {
    return {
      tableData: [],
      totalGift: '',
      totalPeople: '',
      defaultAnchorIcon: require('static/images/default-anchor-icon.png')
    }
  },
  watch: {
    liveStreamLog: {
      handler(val) {
        const start = Number(moment(this.liveStreamLog[0].date.toString()).format('X'))
        this.$showLoading()
        const anchorId = this.$route.params.id || this.$_.get(this.liveStreamLog, '[0].anchor.id')
        this.$get({
          road: 'liveStreamsGiftGiving',
          data: { road: 'gifshow', anchorId },
          params: { mode: 'SEND', time: [start, start + 86400] },
          version: 'v2'
        }).then(res => {
          this.tableData = res.data
          this.totalPeople = res.data.length
          let money = 0
          for (const person of res.data) {
            money += Number(person.currency)
          }
          this.totalGift = money
        }).finally(() => {
          this.$hideLoading()
        })
      },
      immediate: true
    }
  },
  methods: {
    formatDate(date, template = 'YYYY-MM-DD') {
      return moment(date).format(template)
    },
    toDefault(val) {
      // 如有挂榜卖货行为，
      // 链到关联的那场直播详情
      // 如只是刷礼物没直播卖货，
      // 则链到该土豪的达人详情-直播概览
      // 点击未入库的达人，保持当前闪提示：暂无该送礼达人的详细信息
      if (this.$_.get(val, 'anchor.name')) {
        if (this.$_.get(val, 'salesAnchorId') && this.$_.get(val, 'salesAnchorLiveStreamId')) {
          window.location.href =
            `/live/${this.$_.get(val, 'salesAnchorId')}/${this.$_.get(val, 'salesAnchorLiveStreamId')}`
        } else {
          window.location.href = `/anchor/${this.$_.get(val, 'anchor.id')}?banner=2`
        }
      } else {
        this.$toast('暂无该送礼达人的详细信息');
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import './common.less';
</style>